module.exports = __webpack_public_path__ + "assets/e4c96fb125b9e47f1a59e92c234c58f3.png";